import React, { useEffect } from 'react';
import styled from 'styled-components';
import Link from '@g4/next-furniture/Link';

import {
  useTranslations,
  withApplicationQuery,
} from '../graphql/components/ApplicationQueryProvider';
import { useAuthentication } from '../graphql';
import { Box, VerticalSpacing } from '../components/Boneyard';
import SESSION_EXPIRED_PAGE_TRANSLATIONS_QUERY from './sessionExpiredPage/sessionExpiredPageTranslations.query.graphql';
import Markdown from '../components/Markdown';
import PLANE_ICON_LEFT from '../images/pattern-plane-path-top-left.svg';
import PLANE_ICON_RIGHT from '../images/pattern-plane-path-top-right.svg';

const StyledAnchor = styled.a`
  text-decoration: underline;
`;

const SessionExpiredPage = () => {
  const translations = useTranslations();
  const { logout } = useAuthentication();

  const { homepageLinkText, sessionExpiredMessage } = translations.errors;

  const errorBody = sessionExpiredMessage;

  const ErrorBox = styled(Box)`
    text-align: center;
    margin: 0 auto;
    margin-top: 150px;
    min-height: 10em;
    line-height: 1.8;
  `;

  const RightImg = styled.img`
    float: right;
    margin-bottom: 25px;
  `;

  const LeftImg = styled.img`
    float: left;
  `;

  useEffect(() => {
    logout && logout();
  }, [logout]);

  return (
    <ErrorBox>
      <VerticalSpacing size={4} />
      <Markdown source={errorBody} />
      <VerticalSpacing size={2} />
      <Link href="/">
        {({ anchorProps }) => (
          <StyledAnchor {...anchorProps}>{homepageLinkText}</StyledAnchor>
        )}
      </Link>
      <VerticalSpacing size={5} />
      <RightImg src={PLANE_ICON_RIGHT} />
      <LeftImg src={PLANE_ICON_LEFT} />
    </ErrorBox>
  );
};

export default withApplicationQuery(
  SESSION_EXPIRED_PAGE_TRANSLATIONS_QUERY,
  SessionExpiredPage
);
